import React from 'react'
// import CommonBanner
import CommonBanner from '../../component/Common/CommonBanner'
import Media from '../../component/Media'
import MediaHajj from '../../component/MediaHajj'
import { ImageConstants } from '../../assets/img/ImageConstants'
// import AllFaqs
import StaticSEOTags from '../../component/DynamicSEO/StaticSEOTags'
// import { MediaDataa } from "../../component/MediaHajj/MediaData";
// Discover Card
import MediaCard from "../../component/MediaHajj/MediaCard";
  // import SectionHeading from "../../Common/SectionHeading";
  import SectionHeading from "../../component/Common/SectionHeading";

  
import img1 from "../../assets/img/imagination/polani2.jpg"
import img2 from "../../assets/img/imagination/polani3.jpg"
import img3 from "../../assets/img/imagination/polani4.jpg"
import img4 from "../../assets/img/imagination/polani5.jpg"
import img5 from "../../assets/img/imagination/polani7.png"
import img6 from "../../assets/img/imagination/polani8.jpg"
import img7 from "../../assets/img/imagination/polani11.jpg"
import img8 from "../../assets/img/imagination/polani12.jpg"
import img9 from "../../assets/img/imagination/polani15.jpg"
import img10 from "../../assets/img/imagination/polani16.jpg"
// import img17 from "../../assets/img/imagination/polani17.jpg"

export const MediaDataa = [
  {
    img: img1,
    // heading: "Corporate Travel",
    // span: "Read More",
  },
  {
    img: img2,
    // heading: "Worldwide Visa ",
    // span: "Read More",
  },
  {
    img: img3,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img4,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img5,
    // heading: "Worldwide Visa ",
    // span: "Read More",
  },
 
  {
    img: img6,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img7,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
        img: img8,
    // heading: "Worldwide Visa ",
    // span: "Read More",
  },
 
  {
    img: img9,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
  {
    img: img10,
    // heading: "Holidays and Leisure ",
    // span: "Read More",
  },
];


const HajjMedia24 = () => {
  return (
    <>
    <StaticSEOTags
        fallbackTitle="Pakistan's Leading Travel Agency | Polifly Travels"
        fallbackDescription="Discover unforgettable journeys with Polifly Travels. The leading travel agency in Karachi, Pakistan, dedicated to making every trip extraordinary."
        fallbackKeywords="Polifly Travels"
        fallbackOgTitle="Pakistan's Leading Travel Agency | Polifly Travels"
        fallbackOgDescription="Discover unforgettable journeys with Polifly Travels. The leading travel agency in Karachi, Pakistan, dedicated to making every trip extraordinary."
        fallbackCanonicalUrl="https://poliflytravels.com/"
      />
      {/* <CommonBanner heading="Hajj" pagination="Media"/> */}
      <CommonBanner
        heading="Hajj"
         img={ImageConstants.hajjbanner}
        pagination="Media"
      />
      {/* <MediaHajj/> */}



      <section id="go_beyond_area" className="section_padding_top">
        <div className="container">
        <SectionHeading heading="Gallery" />
          <div className="row  g-4 pb-4 align-items-center">
            {/* <div className="col-lg-3 col-md-6 col-sm-6 col-12">
              <div className="heading_left_area">
                <h2>
                  Discover Beyond <span>Boundaries</span>
                </h2>
                <h5 className="text-justify">
                  At House of Polani, we don't just plan trips. We craft
                  journeys that surpass your imagination. Let us guide you to
                  experiences that redefine luxury travel.
                </h5>
              </div>
            </div> */}
            {MediaDataa.map((data, index) => (
              <MediaCard data={data} key={index} />
            ))}
          </div>
        </div>
      </section>
    
    
    </>
  )
}

export default HajjMedia24